import { mobileDefaultPaddingRight, mobileDefaultPaddingLeft } from 'constants/sizes';
import Device from 'constants/deviceSizes';

export default {
  container: {
    width: '100%',
    display: 'flex',
    [Device.mobile]: {
      margin: `10px ${mobileDefaultPaddingRight}px 0px ${mobileDefaultPaddingLeft}px`
    }
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  imageContainer: {
    flexGrow: 1.5
  },
  contentContainer: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundColor: 'rgb(239, 239, 237)',
    backgroundPosition: 'right',
    width: '100%',
    [Device.mobile]: {
      padding: 15
    }
  }
};
